import {WEEKDAY_OPTIONS} from 'src/views/admin/ScheduledJobs/ScheduleSelector';
import {JobEntry} from 'src/views/admin/ScheduledJobs/types';

const timezoneAbbreviation = (): string => String(String(new Date()).split('(')[1]).split(')')[0];

const minutesDescription = (minutes: number): string =>
  `Every ${minutes} Minute${minutes === 1 ? '' : 's'}`;

const dailyDescription = (minutes: number, hour: number): string => {
  const date = new Date();
  date.setMinutes(minutes);
  date.setHours(hour);

  // deal with timezone
  const hours = date.getTimezoneOffset() / 60;
  let newHour = hour - hours;

  if (newHour < 0) {
    newHour += 24;
  }

  const amPm = newHour > 11 ? 'PM' : 'AM';

  if (newHour > 12) {
    newHour -= 12;
  } else if (newHour === 0) {
    newHour = 12;
  }

  const minWithPadding = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
  return 'Every Day at ' + newHour + ':' + minWithPadding + amPm + ' ' + timezoneAbbreviation();
};

const weeklyDescription = (weekday: number, hour: number, minutes: number): string => {
  const date = new Date();
  date.setMinutes(minutes);
  date.setHours(hour);
  const hours = date.getTimezoneOffset() / 60;
  let newHour = hour - hours;
  let newWd = weekday;
  if (newHour < 0) {
    newHour += 24;
    newWd = weekday - 1;
    if (newWd < 1) {
      newWd += 7;
    }
  }
  const amPm = newHour > 11 ? 'PM' : 'AM';
  if (newHour > 12) {
    newHour -= 12;
  } else if (newHour === 0) {
    newHour = 12;
  }
  const minWithPadding = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
  return (
    'Every ' +
    WEEKDAY_OPTIONS[newWd - 1].text +
    ' at ' +
    newHour +
    ':' +
    minWithPadding +
    amPm +
    ' ' +
    timezoneAbbreviation()
  );
};

const monthlyDescription = (dayOfMonth: number, hour: number, minutes: number): string => {
  const date = new Date();
  date.setMinutes(minutes);
  date.setHours(hour);
  const hours = date.getTimezoneOffset() / 60;
  let newHour = hour - hours;
  let newDayOfMonth = dayOfMonth;
  if (newHour < 0) {
    newHour += 24;
    newDayOfMonth = dayOfMonth - 1;
    if (newDayOfMonth < 1) {
      newDayOfMonth += 28;
    }
  }
  const amPm = newHour > 11 ? 'PM' : 'AM';
  if (newHour > 12) {
    newHour -= 12;
  } else if (newHour === 0) {
    newHour = 12;
  }
  const minWithPadding = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
  return (
    'Every ' +
    newDayOfMonth +
    ' of the Month at ' +
    newHour +
    ':' +
    minWithPadding +
    amPm +
    ' ' +
    timezoneAbbreviation()
  );
};

export const scheduleDescription = (jobEntry: JobEntry): string => {
  switch (jobEntry.scheduleType) {
    case 'MINUTE':
      return minutesDescription(jobEntry.min);
    case 'DAILY':
      return dailyDescription(jobEntry.min, jobEntry.hour);
    case 'WEEKLY':
      return weeklyDescription(jobEntry.wd, jobEntry.hour, jobEntry.min);
    case 'MONTHLY':
      return monthlyDescription(jobEntry.dayMo, jobEntry.hour, jobEntry.min);
    default:
      return 'Invalid schedule';
  }
};
